var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32213_212177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2187 24.7197C21.2187 23.2768 22.3898 22.1057 23.8328 22.1057C25.2758 22.1057 26.4469 23.2768 26.4469 24.7197C26.4469 26.1627 25.2758 27.3338 23.8328 27.3338C22.3898 27.3547 21.2187 26.1627 21.2187 24.7197ZM23.8328 13.7197C18.6883 13.7197 14.3803 17.233 13.1674 22.0011C13.1674 22.0429 13.1465 22.0638 13.1465 22.1057C13.1465 22.3984 13.3765 22.6285 13.6693 22.6285H18.1028C18.3119 22.6285 18.5001 22.503 18.5837 22.3148C19.5039 20.3281 21.4906 18.9479 23.8328 18.9479C27.0115 18.9479 29.6047 21.541 29.6047 24.7197C29.6047 27.8984 27.0115 30.4916 23.8328 30.4916C21.5115 30.4916 19.5039 29.1114 18.5837 27.1247C18.5001 26.9365 18.3119 26.811 18.1028 26.811H13.6693C13.3765 26.811 13.1465 27.041 13.1465 27.3338C13.1465 27.3756 13.1465 27.3965 13.1674 27.4384C14.3803 32.2064 18.6883 35.7197 23.8328 35.7197C29.9183 35.7197 34.8537 30.7844 34.8537 24.6988C34.8537 18.6342 29.9183 13.7197 23.8328 13.7197Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32213_212177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7072,
    height: 22,
    fill: "white",
    transform: "translate(13.1465 13.7197)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCi);
export default __webpack_public_path__ + "static/media/CircleCI.d1310a9231d81736335392ac879ffdc3.svg";
export { ForwardRef as ReactComponent };